export const wines = [
  // VALLE CENTRAL - CHILE
  {
    id: 1,
    visible: true,
    name: 'Valle de Chillán Cabernet Sauvignon',
    slug: 'valle-de-chillan-cabernet-sauvignon',
    grape: 'Cabernet Sauvignon',
    classification: 'tinto',
    price: 134.50,
    region: 'Valle Central',
    image: '/images/wine/wine-valle-de-chillan-cabernet-sauvignon.png',
    description: 'Um vigoroso cabernet sauvignon que tem seus taninos aveludados por um maior tempo de estágio em barrica. Aromas de groselha, cassis e um pouco de menta.',
    pairings: ['Carnes vermelhas', 'Carnes grelhadas', 'Churrasco'],
    pairingDescription: 'Cortes de costela, bananinha,T-bone e stinco.',
    technicalDetails: {
      alcohol: '14.5%',
      temperature: '14-18°C',
      aging: 'Passagem por barrica 6-8 meses',
      intensity: 3,
      tannin: 4
    }
  },
  {
    id: 2,
    visible: true,
    name: 'Sweet Cabernet Santa Vita',
    slug: 'sweet-cabernet-santa-vita',
    grape: 'Cabernet Sauvignon',
    classification: 'tinto',
    price: 50.99,
    region: 'Valle Central',
    image: '/images/wine/wine-santa-vita-sweet-cabernet.png',
    description: 'Um vinho fácil de beber, com baixo tanino e com acidez acentuada. Traz bastante frutas ao paladar. Ainda tem aromas adocicados e bastante presença de caramelo e açúcar torrada.',
    pairings: ['Massas', 'Peixes', 'Aves', 'Comida Árabe'],
    pairingDescription: 'Opte por comidas mais leves, como petiscos, azeitonas e embutidos como o espeto romeu e julieta e embutidos.',
    technicalDetails: {
      alcohol: '11%',
      temperature: '16-18°C',
      aging: 'Sem envelhecimento',
      intensity: 2,
      tannin: 1
    }
  },

  
  {
    id: 3,
    visible: true,
    name: 'Quinta do Bons Ventos',
    slug: 'quinta-do-bons-ventos',
    grape: 'Touriga Nacional, Castelão',
    classification: 'tinto',
    price: 59.99,
    region: 'Douro',
    image: '/images/wine/wine-quinta-do-bons-ventos.png',
    description: 'Um vinho abundante em fruta, revela uma cor rubi profunda e uma variedade de aromas, incluindo ameixas, amoras, cassis e toques sutis de flores, ervas e baunilha.',
    pairings: ['Carnes grelhadas', 'Queijos'],
    pairingDescription: 'Uma escolha versátil para uma variedade de pratos, desde cortes suínos,  massas, risotos e queijos mais amarelados.',
    technicalDetails: {
      alcohol: '',
      temperature: '16-18°C',
      aging: '3 meses em carvalho',
      intensity: 3,
      tannin: 3
    }
  },
  {
    id: 4,
    visible: true,
    name: 'Codici Puglia',
    slug: 'codici-puglia',
    grape: 'Negroamaro/Sangiovese',
    classification: 'tinto',
    price: 53.99,
    region: 'Itália',
    image: '/images/wine/wine-codici-puglia.png',
    description: 'Um tinto fácil de beber, com características próprias para ser consumido em uma região quente, apresenta uma cor vermelha brilhante, com aromas envolventes de frutas vermelhas maduras e um sutil toque picante.',
    pairings: ['Queijos', 'Fondues'],
    pairingDescription: 'Massas com carne moída, pizzas e choripan.',
    technicalDetails: {
      alcohol: '13%',
      temperature: '14-18°C',
      aging: 'Sem envelhecimento',
      intensity: 3,
      tannin: 2
    }
  },

  
  {
    id: 5,
    visible: true,
    name: 'Santa Vita Rose',
    slug: 'santa-vita-rose',
    grape: 'Carmenere',
    classification: 'rosé',
    price: 50.99,
    region: 'Valle Central',
    image: '/images/wine/wine-santa-vita-carmenere-rose.png',
    description: 'Um levíssimo rosé chileno que traz uma coloração casca de cebola, rosa claro com aromas florais e frutas brancas como pêssego. Ideal para um paladar leve, fresco e frutado.',
    pairings: ['Happy Hour', 'Frutos do mar', 'Aves', 'Queijos'],
    pairingDescription: 'Ideal para um happy hour combinado com cortes leves de frango, medalhão de queijo coalho e queijos brancos.',
    technicalDetails: {
      alcohol: '12.5%',
      temperature: '10-13°C',
      aging: 'Sem envelhecimento',
      intensity: 2,
      tannin: 1
    }
  },
  {
    id: 6,
    visible: true,
    name: 'Filgueira Merlot',
    slug: 'filgueira-merlot',
    grape: 'Merlot',
    classification: 'tinto',
    price: 99.90,
    region: 'Chile',
    image: '/images/wine/wine-filgueira-merlot.png',
    description: 'Um expressivo merlot que destaca frutas vermelhas como morango e amora em comunhão com um sutil cacau.',
    pairings: ['Carnes vermelhas', 'Carnes grelhadas', 'Queijos'],
    pairingDescription: 'Harmoniza bem carnes vermelhas leves, hambúrguer tradicional, carnes suínas, risotos e queijos cremosos como brie e camembert.',
    technicalDetails: {
      alcohol: '13.5%',
      temperature: '16-18°C',
      aging: 'Sem envelhecimento',
      intensity: 3,
      tannin: 3
    }
  },

  {
    id: 7,
    visible: true,
    name: 'Punti Ferrer Merlot',
    slug: 'punti-ferrer-merlot',
    grape: 'Merlot',
    classification: 'tinto',
    price: 76.90,
    region: 'Valle Central',
    image: '/images/wine/wine-punti-ferrer-merlot.png',
    description: 'Feito com a casta mais tradicional do Chile tem aroma com presença de mirtilo, cassis. Paladar suave, corpo leve e um toque de baunilha',
    pairings: ['Carnes vermelhas', 'Carnes grelhadas'],
    pairingDescription: 'Carnes menos intensas(suínas e bovinas), massas com molhos leves, pratos de aves e  queijos semiduros.',
    technicalDetails: {
      alcohol: '13.5%',
      temperature: '16-18°C',
      aging: 'Sem envelhecimento',
      intensity: 2.5,
      tannin: 3
    }
  },
  {
    id: 8,
    visible: true,
    name: 'Yellow Tail Shiraz',
    slug: 'yellow-tail-shiraz-australia',
    grape: 'Shiraz',
    classification: 'tinto',
    price: 84.99,
    region: 'Australia',
    image: '/images/wine/wine-yellow-tail.png',
    description: 'Da renomada vinícola australiana Yellow Tail, destaca-se pela riqueza da uva Shiraz, e por seu já conhecido sabor rico e encorpado. Tem notas de frutas escuras, caramelo, especiarias sutis e taninos suaves.',
    pairings: ['Carnes vermelhas', 'Carnes grelhadas', 'Churrasco'],
    pairingDescription: 'Hambúrguer Juicy Lucy, hambúrguer fraldinha, cuiabana apimentada, assados em tiras temperado, costela desossada temperada e coxão mole com chimichurri.',
    technicalDetails: {
      alcohol: '13.5%',
      temperature: '16-18°C',
      aging: '3 a 4 meses em carvalho',
      intensity: 4,
      tannin: 3
    }
  },

  {
    id: 9,
    visible: true,
    name: 'San Telmo Malbec',
    slug: 'san-telmo-malbec',
    grape: 'Malbec',
    classification: 'tinto',
    price: 59.99,
    region: 'Mendoza',
    image: '/images/wine/wine-san-telmo.png',
    description: 'Um malbec que traz aromas marcantes de cereja, morango e um delicado toque de violeta. Mais fácil de beber, ideal para o dia a dia.',
    pairings: ['Carnes vermelhas', 'Carnes grelhadas', 'Queijos'],
    pairingDescription: 'Combina muito com cortes mais intensos como Ancho, chorizo e contra filé. Massas e queijos mais amarelados.',
    technicalDetails: {
      alcohol: '14%',
      temperature: '16-18°C',
      aging: 'Sem envelhecimento',
      intensity: 3,
      tannin: 4
    }
  },
  {
    id: 10,
    visible: true,
    name: 'Antares Carmenere',
    slug: 'antares-carmenere',
    grape: 'Carmenere',
    classification: 'tinto',
    price: 76.90,
    region: 'Valle Central',
    image: '/images/wine/wine-antares-carmenere.png',
    description: 'Agradável de beber, com boa acidez e taninos macios, que trazem fluidez e equilíbrio ao vinho. Possui aroma de frutas negras maduras e especiarias, e uma surpreendente nota floral.',
    pairings: ['Carnes vermelhas', 'Carnes grelhadas', 'Queijos'],
    pairingDescription: 'Alcatra, kafta, bife de acém e receitas com patinho.',
    technicalDetails: {
      alcohol: '13.5%',
      temperature: '16-18°C',
      aging: 'sem envelhecimento',
      intensity: 3,
      tannin: 3
    }
  },
  {
    id: 11,
    visible: true,
    name: 'Master Fan Club Malbec',
    slug: 'master-fan-club-malbec',
    grape: 'Malbec',
    classification: 'tinto',
    price: 35.00,
    region: 'Mendoza',
    image: '/images/wine/wine-master-fun-club-malbec.png',
    description: 'Um malbec peculiar pois não envelhece em barrica, tem cor vermelho rubi cativante, oferece aromas convidativos de frutas vermelhas e um toque de pimenta preta. ',
    pairings: ['Carnes vermelhas', 'Carnes grelhadas', 'Churrasco'],
    pairingDescription: 'Combina com picanha, picanha muracha, medalhão angus e pratos mais intensos.',
    technicalDetails: {
      alcohol: '12%',
      temperature: '14-18°C',
      aging: 'Sem envelhecimento',
      intensity: 4,
      tannin: 3
    }
  },

  {
    id: 12,
    visible: true,
    name: 'La Tierra Rocosa Merlot',
    slug: 'la-tierra-rocosa-merlot',
    grape: 'Merlot',
    classification: 'tinto',
    price: 35.00,
    region: 'Chile',
    image: '/images/wine/wine-la-tierra-rocosa-merlot.png',
    description: 'Possui uma cor vermelho rubi intensa e brilhante, com aromas sedutores de frutas vermelhas maduras, como amora e cereja, acompanhados de notas suaves de especiarias e toques sutis de carvalho.',
    pairings: ['Carnes vermelhas', 'Carnes grelhadas', 'Churrasco'],
    pairingDescription: 'Combina bem com pratos de carnes vermelhas não tão intensas(baby beef, carpaccio, shoulder), cortes suínos, massas e queijos de média intensidade.',
    technicalDetails: {
      alcohol: '',
      temperature: '16-18°C',
      aging: 'Sem envelhecimento',
      intensity: 3,
      tannin: 2
    }
  },
  {
    id: 13,
    visible: true,
    name: 'Santa Maria Apalta Carmenere',
    slug: 'santa-maria-apalta-carmenere',
    grape: 'Carmenere',
    classification: 'tinto',
    price: 71.99,
    region: 'Valle Central',
    image: '/images/wine/wine-santa-maria-carmenere.png',
    description: 'Um carmenere mais vigoroso que repousa 10 meses em barrica de carvalho. Tem notas de frutas vermelhas e cacau.',
    pairings: ['Carnes vermelhas', 'Carnes grelhadas', 'Queijos'],
    pairingDescription: 'Cortes não tão estruturados como peixinho e nossa almôndega com queijo.',
    technicalDetails: {
      alcohol: '12.5%',
      temperature: '16-18°C',
      aging: '10 meses em barrica',
      intensity: 3,
      tannin: 3
    }
  },

  {
    id: 14,
    visible: true,
    name: 'Ventisqueiro Cabernet Sauvignon Reserva',
    slug: 'ventisqueiro-cabernet-sauvignon-reserva',
    grape: 'Cabernet Sauvignon',
    classification: 'tinto',
    price: 79.99,
    region: 'Chile',
    image: '/images/wine/wine-ventisqueiro-carbernet-sauvignon.png',
    description: 'Com a casta mais famosa do mundo este chileno oferta cor rubi intensa, e revela aromas de frutas vermelhas, pimenta, tabaco e chocolate, provenientes da guarda em barricas.',
    pairings: ['Carnes vermelhas', 'Carnes grelhadas', 'Queijos'],
    pairingDescription: 'Acompanha queijos maduros, ancho, carré de cordeiro e todos os cortes de costela.',
    technicalDetails: {
      alcohol: '14.5%',
      temperature: '16-18°C',
      aging: '10 meses em barrica de carvalho',
      intensity: 4,
      tannin: 4
    }
  },

  // MENDOZA - ARGENTINA
  {
    id: 15,
    visible: true,
    name: 'Master Fan Club Rosé',
    slug: 'master-fan-club-rose',
    grape: 'Bonarda/Malbec',
    classification: 'rosé',
    price: 35.00,
    region: 'Mendoza',
    producer: 'Andean Vineyards/Bodega San Telmo',
    image: '/images/wine/wine-master-clube.png',
    description: 'Um refrescante rosé argentino que utiliza as castas bonarda e malbec e surpreende pelo aroma mais intenso de morango, groselha e cereja.',
    pairings: ['Frutos do mar', 'Peixes', 'Aves', 'Sushi', 'Saladas', 'Vegetais'],
    pairingDescription: 'Coxinha da asa temperada, tulipa de frango temperada, linguiça de frango recheada, queijos semi duros.',
    technicalDetails: {
      alcohol: '12.5%',
      temperature: '10-13°C',
      aging: 'Sem envelhecimento em barrica',
      intensity: 2,
      tannin: 1
    }
  },

  // REGIÃO PORTUGAL - VINHO VERDE
  {
    id: 16,
    visible: true,
    name: 'Calamares Verde',
    slug: 'calamares-verde',
    grape: 'Loureiro/Trajadura',
    classification: 'branco',
    price: 57.99,
    region: 'Douro',
    image: '/images/wine/wine-branco-calamares.png',
    description: 'Com uma embalagem de design marcante, é um refrescante branco meio seco, com destaque para as notas cítricas e de maçã verde.',
    pairings: ['Peixes', 'Aves'],
    pairingDescription: 'Ideal para harmonizar com pratos leves, aves em geral, peixes e frutos do mar.',
    technicalDetails: {
      alcohol: '11.5%',
      temperature: '7-12°C',
      aging: 'Sem envelhecimento',
      intensity: 2,
      tannin: 2
    }
  },

  // REGIÃO URUGUAI - TANNAT
  {
    id: 17,
    visible: true,
    name: 'Filgueira Tannat',
    slug: 'filgueira-tannat',
    grape: 'Tannat',
    classification: 'tinto',
    price: 99.90,
    region: 'Uruguai',
    image: '/images/wine/wine-filgueira-tannat.png',
    description: 'Feito com a principal uva uruguaia é o reflexo da potência da uva tannat, com muito caráter e sensação tânica intensa, sabores profundos de frutas maduras, acompanhados por notas de chocolate, tabaco e madeira.',
    pairings: ['Carnes vermelhas', 'Carnes grelhadas', 'Churrasco'],
    pairingDescription: 'Experimente com assado de tira, cortes de carneiro e pratos com molhos fortes.',
    technicalDetails: {
      alcohol: '14%',
      temperature: '16-18°C',
      aging: 'Sem envelhecimento',
      intensity: 5,
      tannin: 4
    }
  },

  // REGIÃO URUGUAI - TANNAT/CABERNET FRANC
  {
    id: 18,
    visible: true,
    name: 'Filgueira Tannat/Cabernet Franc',
    slug: 'filgueira-tannat-cabernet-franc',
    grape: 'Tannat/Cabernet Franc',
    classification: 'tinto',
    price: 99.90,
    region: 'Uruguai',
    image: '/images/wine/wine-filgueira-tannat-cabernet-franc.png',
    description: 'Um surpreendente corte que adiciona cabernet franc ao potente Tannat suavizando sua rusticidade, e entrega notas de frutas escuras e vermelhas, especiarias e toques herbáceos. Combina potência com frescor.',
    pairings: ['Carnes vermelhas', 'Carnes grelhadas'],
    pairingDescription: 'Harmoniza bem com carnes mais intensas como cordeiro, carnes defumadas e fia fiori.',
    technicalDetails: {
      alcohol: '14%',
      temperature: '16-18°C',
      aging: 'Sem envelhecimento',
      intensity: 4,
      tannin: 4
    }
  },

  // REGIÃO URUGUAI - CABERNET SAUVIGNON
  {
    id: 19,
    visible: true,
    name: 'Filgueira Cabernet Sauvignon',
    slug: 'filgueira-cabernet-sauvignon',
    grape: 'Cabernet Sauvignon',
    classification: 'tinto',
    price: 99.90,
    region: 'Uruguai',
    image: '/images/wine/wine-filgueira-merlot.png',
    description: 'Uma nova proposta de uva do vinho uruguaio que tem se mostrado bem surpreendente e potente. Aroma de cereja negra e groselha.',
    pairings: ['Carnes vermelhas', 'Carnes grelhadas', 'Churrasco'],
    pairingDescription: 'Harmoniza com os cortes mais intensos e de mais gordura entremeada e pratos de cordeiro.',
    technicalDetails: {
      alcohol: '14%',
      temperature: '16-18°C',
      aging: 'Sem envelhecimento',
      intensity: 4,
      tannin: 4
    }
  },

  // REGIÃO URUGUAI - FUGA TANNAT
  {
    id: 20,
    visible: true,
    name: 'Fuga Tannat',
    slug: 'fuga-tannat',
    grape: 'Tannat',
    classification: 'tinto',
    price: 45.00,
    region: 'Uruguai',
    image: '/images/wine/wine-fuga-tannat.png',
    description: 'Um Tannat mais fresco e rústico que expressa mais intensamente a fruta negra madura como groselha e cereja.',
    pairings: ['Carnes vermelhas', 'Carnes grelhadas'],
    pairingDescription: 'Harmoniza muito bem com cortes de cordeiro e com cortes mais intensos como as nossas costelas.',
    technicalDetails: {
      alcohol: '13.5%',
      temperature: '16-18°C',
      aging: 'Sem envelhecimento',
      intensity: 4,
      tannin: 5
    }
  },

  // REGIÃO URUGUAI - FUGA MERLOT
  {
    id: 21,
    visible: true,
    name: 'Fuga Merlot',
    slug: 'fuga-merlot',
    grape: 'Merlot',
    classification: 'tinto',
    price: 45.00,
    region: 'Uruguai',
    image: '/images/wine/wine-fuga-merlot.png',
    description: 'Um vinho bastante agradável ao paladar, frutado e com aromas de cereja e mirtilo.',
    pairings: ['Carnes vermelhas', 'Massas', 'Queijos'],
    pairingDescription: 'Combina bem com pratos de carnes vermelhas (linguiças, maia) costela e barriga de porco, massas e queijos de média intensidade.',
    technicalDetails: {
      alcohol: '13%',
      temperature: '16-18°C',
      aging: 'Sem envelhecimento',
      intensity: 3,
      tannin: 3
    }
  },

  // REGIÃO ARGENTINA - DV MALBEC
  {
    id: 22,
    visible: true,
    name: 'DV Malbec',
    slug: 'dv-malbec',
    grape: 'Malbec',
    classification: 'tinto',
    price: 204.50,
    region: 'Mendoza',
    image: '/images/wine/wine-dv-catena-malbec.png',
    description: 'Um tinto que une a exuberância do malbec com a elegância da cabernet sauvignon. Possui aromas de frutas negras maduras e nuances de tabaco e baunilha.',
    pairings: ['Carnes vermelhas', 'Churrasco'],
    pairingDescription: 'Churrasco com picanha, assado de tira e receitas mais encorpadas.',
    technicalDetails: {
      alcohol: '14.5%',
      temperature: '16-18°C',
      aging: '12 meses em barrica',
      intensity: 4,
      tannin: 3
    }
  },

  // REGIÃO ARGENTINA - DV CHARDONNAY
  {
    id: 23,
    visible: true,
    name: 'DV Chardonnay',
    slug: 'dv-chardonnay',
    grape: 'Chardonnay',
    classification: 'branco',
    price: 189.90,
    region: 'Mendoza',
    image: '/images/wine/wine-white-dv-catena-chardonnay.png',
    description: 'Uma das referências para os chardonnay da América do Sul, mostra concentração e finesse, com aromas de pêssego e cítricos provenientes dos dois vinhedos utilizados.',
    pairings: ['Peixes', 'Aves'],
    pairingDescription: 'Combina com peixes com sabores mais intensos como salmão, linguiças de frango e cortes de aves mais intensos como frango afropelado e tulipa recheada.',
    technicalDetails: {
      alcohol: '13.5%',
      temperature: '7-12°C',
      aging: '6 meses em barricas de carvalho',
      intensity: 3,
      tannin: 1
    }
  },

  // REGIÃO ARGENTINA - ALMA NEGRA
  {
    id: 24,
    visible: true,
    name: 'Alma Negra',
    slug: 'alma-negra',
    grape: 'Bonarda/Malbec',
    classification: 'tinto',
    price: 222.50,
    region: 'Mendoza',
    image: '/images/wine/wine-alma-negra.png',
    description: 'O famoso e misterioso vinho argentino que tem como atrativo não revelar o percentual de cada uma das castas que coloca, sendo usado Bonarda e Malbec. É muito, com um sutil toque tostado.',
    pairings: ['Carnes vermelhas', 'Carnes grelhadas', 'Massas'],
    pairingDescription: 'Harmoniza bem com todas as carnes vermelhas assadas ou grelhadas, massas com molhos encorpados, e queijos duros e semiduros.',
    technicalDetails: {
      alcohol: '14%',
      temperature: '16-18°C',
      aging: '12 meses em carvalho',
      intensity: 4,
      tannin: 3
    }
  },

  {
    id: 25,
    visible: true,
    name: 'Vinho Luccarelli Puglia',
    slug: 'luccarelli-puglia',
    grape: 'Primitivo',
    classification: 'tinto',
    price: 69.99,
    region: 'Itália',
    image: '/images/wine/wine-codici-puglia.png',
    description: 'Este versátil vinho, feito com a casta Primitivo, expressa o terroir da região da Puglia, com aromas intensos de frutas negras maduras e especiarias, e toques de ervas aromáticas.',
    pairings: ['Massas', 'Carnes vermelhas'],
    pairingDescription: 'Massas com carne moída, pizzas e choripan.',
    technicalDetails: {
      alcohol: '13.5%',
      temperature: '16-18°C',
      aging: 'Sem envelhecimento',
      intensity: 3,
      tannin: 3
    }
  },

  {
    id: 26,
    visible: true,
    name: 'Vinho Nederburg Shiraz',
    slug: 'nederburg-shiraz',
    grape: 'Shiraz',
    classification: 'tinto',
    price: 59.90,
    region: 'África do Sul',
    image: '/images/wine/wine-nederburg-shiraz.png',
    description: 'Feito pela famosa vinícola sul africana este Shiraz apresenta aromas de frutas vermelhas maduras e especiarias como cravo e canela.',
    pairings: ['Carnes vermelhas', 'Churrasco'],
    pairingDescription: 'Hambúrguer Juicy Lucy, hambúrguer fraldinha, cuiabana apimentada, assados em tiras temperado, costela desossada temperada e coxão mole com chimichurri.',
    technicalDetails: {
      alcohol: '14%',
      temperature: '16-18°C',
      aging: 'Sem envelhecimento',
      intensity: 4,
      tannin: 3
    }
  },

  {
    id: 27,
    visible: true,
    name: 'Vinho Malbec Norton',
    slug: 'malbec-norton',
    grape: 'Malbec',
    classification: 'tinto',
    price: 98.50,
    region: 'Mendoza',
    image: '/images/wine/wine-norton-malbec.png',
    description: 'O Norton Malbec é proveniente de Lujan de Cuyo, uma das melhores regiões vinícolas do mundo. É um ícone dos vinhos argentinos, caracterizado por seu encorpado robusto, corpo, cor intensa, aromas doces e a final persistente.',
    pairings: ['Carnes vermelhas', 'Churrasco'],
    pairingDescription: 'Churrasco com picanha, contra filé, assado de tira e receitas mais encorpadas.',
    technicalDetails: {
      alcohol: '14%',
      temperature: '16-18°C',
      aging: '12 meses em carvalho',
      intensity: 4,
      tannin: 3
    }
  },

  {
    id: 28,
    visible: true,
    name: 'Vinho Pata Negra Cabernet Sauvignon',
    slug: 'pata-negra-cabernet-sauvignon',
    grape: 'Tempranillo/Cabernet Sauvignon',
    classification: 'tinto',
    price: 59.90,
    region: 'Rioja',
    image: '/images/wine/wine-pata-negra.png',
    description: 'De cor rubi intenso possui aromas de frutas vermelhas, notas de pimenta preta, ervas secas e tostado. Revela bom volume e taninos suaves e redondos.',
    pairings: ['Carnes vermelhas', 'Massas', 'Queijos'],
    pairingDescription: 'Harmoniza com receitas com carnes vermelhas de média intensidade, massa de molhos condimentados e queijos meia cura.',
    technicalDetails: {
      alcohol: '13.5%',
      temperature: '16-18°C',
      aging: 'Sem envelhecimento',
      intensity: 4,
      tannin: 3
    }
  }
];

export const categories = [
  {
    id: 'grape',
    title: 'POR TIPO DE UVA',
    subtitle: 'Vinhos por Tipo de Uva',
  },
  {
    id: 'price',
    title: 'POR PREÇO',
    subtitle: 'Vinhos por Preço',
  },
  {
    id: 'region',
    title: 'POR REGIÃO',
    subtitle: 'Vinhos por Região',
  },
  {
    id: 'pairing',
    title: 'POR HARMONIZAÇÃO',
    subtitle: 'Vinhos para Harmonizar',
  }
];

export const foods = [

  {
    id: 'churrasco',
    name: 'Churrasco',
    icon: '🔥',
    description: 'Churrasco brasileiro tradicional com diversos cortes nobres de carne bovina, suína e linguiças artesanais',
    examples: ['Picanha', 'Costela', 'Linguiça', 'Fraldinha']
  },
  {
    id: 'carnes-vermelhas',
    name: 'Carnes Vermelhas',
    icon: '🥩',
    description: 'Carnes bovinas nobres grelhadas, assadas ou na brasa, preparadas com técnicas tradicionais e temperos especiais',
    examples: ['Picanha', 'Bife Ancho', 'Costela']
  },
  {
    id: 'carnes-grelhadas',
    name: 'Carnes Grelhadas',
    icon: '🍖',
    description: 'Carnes suínas, bovinas e de aves preparadas na grelha, realçando o sabor natural com marinadas aromáticas',
    examples: ['Frango Grelhado', 'Lombo', 'Medalhões']
  },
  {
    id: 'massas',
    name: 'Massas',
    icon: '🍝',
    description: 'Massas artesanais e tradicionais com molhos diversos, desde os clássicos italianos até as receitas contemporâneas',
    examples: ['Espaguete à Bolonhesa', 'Lasanha']
  },
  {
    id: 'queijos',
    name: 'Queijos',
    icon: '🧀',
    description: 'Seleção de queijos artesanais e importados, tábuas especiais e pratos com queijos fundidos ou gratinados',
    examples: ['Brie', 'Gouda', 'Parmesão', 'Gorgonzola']
  },
  {
    id: 'fondues',
    name: 'Fondues',
    icon: '🫕',
    description: 'Fondues tradicionais de queijos suíços e franceses, ou de chocolate belga para momentos especiais e aconchegantes',
    examples: ['Fondue de Queijos Suíços', 'Fondue de Chocolate']
  },

  {
    id: 'peixes',
    name: 'Peixes e Frutos do Mar',
    icon: '🐟',
    description: 'Peixes frescos, frutos do mar nobres e crustáceos preparados de forma simples ou com molhos sofisticados',
    examples: ['Salmão', 'Camarão', 'Bacalhau']
  },
  {
    id: 'aves',
    name: 'Aves',
    icon: '🍗',
    description: 'Frango, peru e outras aves assadas, grelhadas ou em preparos especiais com temperos e ervas aromáticas',
    examples: ['Frango Assado', 'Peru', 'Chester']
  },

  {
    id: 'comida-arabe',
    name: 'Comida Árabe',
    icon: '🧆',
    description: 'Culinária árabe autêntica rica em especiarias, cordeiro, grão de bico, tahine e ingredientes mediterrâneos frescos',
    examples: ['Kibe', 'Esfiha', 'Falafel', 'Homus', 'Kafta', 'Tabule']
  }
];

export const regions = [
  {
    id: 'mendoza',
    name: 'Mendoza',
    country: 'Argentina',
    flag: '🇦🇷',
    description: 'Principal região vinícola da Argentina, famosa pelos Malbecs',
    characteristics: 'Altitude elevada, clima seco, ideal para tintos encorpados',
    highlights: ['Malbec', 'Cabernet Sauvignon', 'Syrah']
  },
  {
    id: 'valle-central',
    name: 'Valle Central',
    country: 'Chile',
    flag: '🇨🇱',
    description: 'Coração da produção vinícola chilena com excelente custo-benefício',
    characteristics: 'Clima mediterrâneo, perfeito para Carmenere',
    highlights: ['Carmenere', 'Cabernet Sauvignon', 'Merlot']
  },
  {
    id: 'chile',
    name: 'Chile',
    country: 'Chile',
    flag: '🇨🇱',
    description: 'Vinhos chilenos de diversas regiões com excelente qualidade e custo-benefício',
    characteristics: 'Clima diversificado, variedade de terroirs',
    highlights: ['Merlot', 'Cabernet Sauvignon', 'Carmenere']
  },
  {
    id: 'douro',
    name: 'Douro',
    country: 'Portugal',
    flag: '🇵🇹',
    description: 'Região histórica, berço do Vinho do Porto',
    characteristics: 'Terroir único, vinhas em terraços',
    highlights: ['Touriga Nacional', 'Tinta Roriz', 'Vinho do Porto']
  },
  {
    id: 'toscana',
    name: 'Toscana',
    country: 'Itália',
    flag: '🇮🇹',
    description: 'Região icônica, famosa pelos Chianti e Super Tuscans',
    characteristics: 'Colinas ensolaradas, elegância e tradição',
    highlights: ['Sangiovese', 'Brunello', 'Chianti']
  },
  {
    id: 'bordeaux',
    name: 'Bordeaux',
    country: 'França',
    flag: '🇫🇷',
    description: 'Região vinícola mais prestigiada do mundo',
    characteristics: 'Assemblages complexas, vinhos de guarda',
    highlights: ['Cabernet Sauvignon', 'Merlot', 'Cabernet Franc']
  },
  {
    id: 'rioja',
    name: 'Rioja',
    country: 'Espanha',
    flag: '🇪🇸',
    description: 'Principal região vinícola espanhola, tradição e qualidade',
    characteristics: 'Envelhecimento em carvalho, elegância',
    highlights: ['Tempranillo', 'Garnacha', 'Graciano']
  },
  {
    id: 'napa-valley',
    name: 'Napa Valley',
    country: 'Estados Unidos',
    flag: '🇺🇸',
    description: 'Região premium da Califórnia, vinhos de alto padrão',
    characteristics: 'Clima ideal, tecnologia e inovação',
    highlights: ['Cabernet Sauvignon', 'Chardonnay', 'Pinot Noir']
  },
  {
    id: 'vale-dos-vinhedos',
    name: 'Vale dos Vinhedos',
    country: 'Brasil',
    flag: '🇧🇷',
    description: 'Principal região vinícola brasileira no Rio Grande do Sul',
    characteristics: 'Primeira D.O. do Brasil, vinhos de altitude',
    highlights: ['Merlot', 'Cabernet Sauvignon', 'Chardonnay']
  },
  {
    id: 'uruguai',
    name: 'Uruguai',
    country: 'Uruguai',
    flag: '🇺🇾',
    description: 'Pequeno país com grande tradição vinícola, famoso pela uva Tannat',
    characteristics: 'Clima atlântico, vinhos potentes e estruturados',
    highlights: ['Tannat', 'Merlot', 'Cabernet Franc']
  },
  {
    id: 'africa-do-sul',
    name: 'África do Sul',
    country: 'África do Sul',
    flag: '🇿🇦',
    description: 'País com tradição vinícola crescente, produz vinhos de excelente qualidade',
    characteristics: 'Clima mediterrâneo, diversidade de terroirs',
    highlights: ['Shiraz', 'Pinotage', 'Chenin Blanc']
  }
];

